import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '../i18n'
//首页
const Home = () => import(/* webpackChunkName: "page-home" */ '../pages/home/index.vue')
const Mine = () => import(/* webpackChunkName: "page-mine" */ '../pages/mine/index.vue')
const Choose = () => import(/* webpackChunkName: "page-choose" */ '../pages/choose/index.vue')
const Pl = () => import(/* webpackChunkName: "page-pl" */ '../pages/pl/index.vue')
const PinglunDetail = () => import(/* webpackChunkName: "page-pinglun-detail" */ '../pages/pl/PinglunDetail.vue')
const List = () => import(/* webpackChunkName: "page-list" */ '../pages/choose/list.vue')
const Profile = () => import(/* webpackChunkName: "page-profile" */ '../pages/choose/profile.vue')
const Video = () => import(/* webpackChunkName: "page-video" */ '../pages/video/index.vue')
const Game = () => import(/* webpackChunkName: "page-game" */ '../pages/game/index.vue')
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
const ServiceOnline = () => import(/* webpackChunkName: "page-service-online" */ '../pages/mine/ServiceOnline.vue')
const ServicePage = () => import(/* webpackChunkName: "page-service-page" */ '../pages/mine/ServicePage.vue')
const Setting = () => import(/* webpackChunkName: "page-setting" */ '../pages/mine/Setting.vue')
const IndexInfo = () => import(/* webpackChunkName: "page-index-info" */ '../pages/mine/IndexInfo.vue')
const Infomation = () => import(/* webpackChunkName: "page-infomation" */ '../pages/mine/Infomation.vue')
const Setname = () => import(/* webpackChunkName: "page-setname" */ '../pages/mine/Setname.vue')
const Setsex = () => import(/* webpackChunkName: "page-setsex" */ '../pages/mine/Setsex.vue')
const SetPayPassword = () => import(/* webpackChunkName: "page-set-pay-password" */ '../pages/mine/SetPayPassword.vue')
const SetLoginPassword = () => import(/* webpackChunkName: "page-set-login-password" */ '../pages/mine/SetLoginPassword.vue')
// The active betting route uses the purchase-number/certification layout.
// The alternate component remains in source only as a rollback option.
const Lottery = () => import(/* webpackChunkName: "page-lottery" */ '../pages/lottery/index.vue')
const Notice = () => import(/* webpackChunkName: "page-notice" */ '../pages/mine/Notice.vue')
const PlayVideo = () => import(/* webpackChunkName: "page-play-video" */ '../pages/video/PlayVideo')
const Setbank = () => import(/* webpackChunkName: "page-setbank" */ '../pages/mine/Setbank')
const BindCard = () => import(/* webpackChunkName: "page-bind-card" */ '../pages/mine/BindCard')
const Withdraw = () => import(/* webpackChunkName: "page-withdraw" */ '../pages/mine/Withdraw')
const BindCryptoAddress = () => import(/* webpackChunkName: "page-bind-crypto-address" */ '../pages/mine/BindCryptoAddress')
const Recharge = () => import(/* webpackChunkName: "page-recharge" */ '../pages/mine/Recharge')
const RechargeList = () => import(/* webpackChunkName: "page-recharge-list" */ '../pages/mine/RechargeList.vue')
const LoanCenter = () => import(/* webpackChunkName: "page-loan-center" */ '../pages/mine/LoanCenter.vue')
const LoanRecords = () => import(/* webpackChunkName: "page-loan-records" */ '../pages/mine/LoanRecords.vue')
const LoanRepayment = () => import(/* webpackChunkName: "page-loan-repayment" */ '../pages/mine/LoanRepayment.vue')
const Personalreport = () => import(/* webpackChunkName: "page-personalreport" */ '../pages/mine/Personalreport')
const GameRecord = () => import(/* webpackChunkName: "page-game-record" */ '../pages/mine/GameRecord')
const GameDetail = () => import(/* webpackChunkName: "page-game-detail" */ '../pages/mine/GameDetail')
const WithdrawRecord = () => import(/* webpackChunkName: "page-withdraw-record" */ '../pages/mine/WithdrawRecord')
const MoneyLog = () => import(/* webpackChunkName: "page-money-log" */ '../pages/mine/MoneyLog')
const Mymove = () => import(/* webpackChunkName: "page-mymove" */ '../pages/mine/Mymove')
const CacheManagement = () => import(/* webpackChunkName: "page-cache-management" */ '../pages/mine/CacheManagement')
const VipCenter = () => import(/* webpackChunkName: "page-vip-center" */ '../pages/mine/VipCenter.vue')






Vue.use(VueRouter)
const routes = [
    {path:'/',redirect:'/Home',component:Home,meta:{title:'로맨틱'}},
    {path:'/Home',name:'home',component:Home,meta:{title:'로맨틱'}},
	{path:'/Choose',name:'choose',component:Choose,meta:{title:'로맨틱-프로필'}},
	{path:'/Pl',name:'pl',component:Pl,meta:{title:'매니저 후기'}},
	{path:'/PinglunDetail',name:'PinglunDetail',component:PinglunDetail,meta:{title:'매니저 후기'}},
	{path:'/List',name:'list',component:List,meta:{title:'프로필'}},
	{path:'/Profile',name:'profile',component:Profile,meta:{title:'프로필'}},
    {path:'/Mine',name:'mine',component:Mine,meta:{title:'로맨틱-나의'}},
    {path:'/Video',name:'video',component:Video,meta:{title:'비디오'}},
    {path:'/Game',name:'game',component:Game,meta:{title:'게임'}},
    {path:'/Login',name:'login',component:Login,meta:{title:'로그인'}},
    {path:'/Register',name:'register',component:Register,meta:{title:'등록'}},
    {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:'온라인 고객센터'}},
    {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:'온라인 고객센터'}},
    {path:'/Setting',name:'Setting',component:Setting,meta:{title:'설치'}},
    {path:'/IndexInfo',name:'IndexInfo',component:IndexInfo,meta:{title:'Settings'}},
    {path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:'프로파일'}},
    {path:'/Setname',name:'Setname',component:Setname,meta:{title:'실명 수정'}},
    {path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:'성별 수정'}},
    {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{title:'결제 비밀번호 관리'}},
    {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:'로그인 암호 관리'}},
    {path:'/Language',redirect:'/Setting'},
    {path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:'상세 정보 페이지'}},
    {path:'/Notice',name:'Notice',component:Notice,meta:{title:'로맨틱-정보 공지'}},
    {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:'비디오 재생'}},
    {path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:'수금 카드를 기입하다'}},
    {path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:'수금 카드를 기입하다'}},
    {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:'현금 인출'}},
    {path:'/BindCryptoAddress',name:'BindCryptoAddress',component:BindCryptoAddress,meta:{title:'Bind Withdrawal Address'}},
    {path:'/Recharge',name:'Recharge',component:Recharge,meta:{title:'충전'}},
    {path:'/RechargeList',name:'RechargeList',component:RechargeList,meta:{title:'Deposit History'}},
    {path:'/LoanCenter',name:'LoanCenter',component:LoanCenter,meta:{title:'Loan Center'}},
    {path:'/LoanRecords',name:'LoanRecords',component:LoanRecords,meta:{title:'Loan Records'}},
    {path:'/LoanRepayment',name:'LoanRepayment',component:LoanRepayment,meta:{title:'Loan Repayment'}},
    {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:'Personal Report'}},
    {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:'현금 인출 기록'}},
    {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:'작업 레코드'}},
    {path:'/GameDetail',name:'GameDetail',component:GameDetail,meta:{title:'작업 상세 정보'}},
    {path:'/MoneyLog',name:'MoneyLog',component:MoneyLog,meta:{title:'잔액 기록'}},
    {path:'/Mymove',name:'Mymove',component:Mymove,meta:{title:'로맨틱-내 영화'}},
    {path:'/CacheManagement',name:'CacheManagement',component:CacheManagement,meta:{title:'Cache Management'}},
    {path:'/VipCenter',name:'VipCenter',component:VipCenter,meta:{title:'VIP Center'}},


];

//生成路由实例
const router = new VueRouter({
    routes
})

function emitRouteFeedback(name) {
    if (typeof window === 'undefined' || typeof window.CustomEvent !== 'function') return
    window.dispatchEvent(new CustomEvent(name))
}

router.beforeEach((to,from,next) => {         //修改标题路由配置加上这个
    emitRouteFeedback('app-route-loading-start')
    const titleKeys = {
        login: 'login.doLogin',
        register: 'register.register',
        video: 'video.title',
        mine: 'common.minenav',
        ServiceOnline: 'kefu.title',
        ServicePage: 'kefu.title',
        Setting: 'setting.title',
        Infomation: 'mine.infomation',
        Withdraw: 'withdraw.title',
        Recharge: 'mine.recharge',
        WithdrawRecord: 'mine.withdrawrecord',
        MoneyLog: 'moneylog.title',
        Mymove: 'mine.mymove'
    }
    const titleKey = titleKeys[to.name]
    const pageTitle = titleKey ? i18n.t(titleKey) : ''
    document.title = to.path === '/' || to.path === '/Home' || !pageTitle
        ? 'Love Light'
        : `${pageTitle} - Love Light`
    next()
})

// 在生成路由实例后直接添加这一行：
router.push = (location) => {
    return VueRouter.prototype.push.call(router, location).catch((error) => {
        emitRouteFeedback('app-route-loading-end')
        return error
    })
}

router.afterEach((to) => {
    window.requestAnimationFrame(() => emitRouteFeedback('app-route-loading-end'))
    if (to.path !== '/Login' && to.path !== '/Register') return

    const currentUrl = new URL(window.location.href)
    const expectedPath = to.path
    currentUrl.searchParams.delete('_appv')
    currentUrl.pathname = expectedPath
    currentUrl.hash = `#${to.fullPath}`

    const canonicalUrl = `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`
    const activeUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`
    if (canonicalUrl !== activeUrl) window.history.replaceState(window.history.state, '', canonicalUrl)
})

router.onError(() => emitRouteFeedback('app-route-loading-end'))

export default router
